import { LuCheck, LuDownload, LuFlag, LuTrash2 } from "react-icons/lu";
import { Button } from "@/components/ui/button";
import { ButtonGroup } from "@/components/ui/button-group";

export function ReviewActions({
  disabled,
  onApprove,
  onFlag,
  onDelete,
  approving,
  pdfUrl,
  pdfDisabled,
}: {
  disabled: boolean;
  onApprove: () => void;
  onFlag: () => void;
  onDelete: () => void;
  approving: boolean;
  pdfUrl: string;
  /** A script with no pages has nothing to export. */
  pdfDisabled: boolean;
}) {
  return (
    <ButtonGroup className="w-full">
      <Button className="flex-1" disabled={disabled || approving} onClick={onApprove}>
        <LuCheck />
        Approve
      </Button>
      <Button variant="outline" className="flex-1" disabled={disabled} onClick={onFlag}>
        <LuFlag />
        Flag
      </Button>
      {/* An anchor, not a fetch: the server sends the PDF as an attachment,
          so the browser's own download handles progress and saving. */}
      <Button
        variant="outline"
        size="icon-md"
        aria-label="Download script as PDF"
        title="Download PDF"
        disabled={pdfDisabled}
        render={<a href={pdfUrl} download target="_blank" rel="noreferrer" />}
      >
        <LuDownload />
      </Button>
      <Button variant="destructive-outline" size="icon-md" onClick={onDelete} aria-label="Delete script">
        <LuTrash2 />
      </Button>
    </ButtonGroup>
  );
}
